// extracted by mini-css-extract-plugin
export var actionButton = "_70-1";
export var actionButtons = "_70-2";
export var actions = "_70-0";
export var aiUnread = "_70-10";
export var alignCenter = "_70-h";
export var backWrapper = "_70-3";
export var cellContainer = "_70-4";
export var checkboxContainer = "_70-5";
export var contentContainer = "_70-6";
export var contentHeader = "_70-8";
export var conversationsTableWrapper = "_70-s";
export var draftReplyBadgeContainer = "_70-m";
export var dropdownItem = "_70-b";
export var dropdownItemsContainer = "_70-a";
export var dropdownTitle = "_70-c";
export var errorIcon = "_70-7";
export var filter = "_70-d";
export var gray = "_70-i";
export var headerActionButtons = "_70-e";
export var headerCheckboxContainer = "_70-f";
export var icon = "_70-j";
export var menuContainer = "_70-k";
export var noMoreTicketsIcon = "_70-12";
export var noMoreTicketsSubText = "_70-13";
export var oneLine = "_70-l";
export var optionsButton = "_70-n";
export var plus = "_70-o";
export var portalButtonsWrapper = "_70-g";
export var red = "_70-p";
export var scrolledTop = "_70-9";
export var search = "_70-q";
export var selectedConversationsCount = "_70-r";
export var spinner = "_70-t";
export var strong = "_70-u";
export var summaryCell = "_70-v";
export var tableContainer = "_70-11";
export var tagContainer = "_70-w";
export var threeDots = "_70-x";
export var twoLines = "_70-y";
export var unread = "_70-z";